import { compose, withStateHandlers, lifecycle } from 'recompose';
import { injectIntl } from 'react-intl';
import { addIntlProps } from 'utils/recompose';
import combineSelectors from 'utils/combineSelectors';
import { connect } from 'react-redux';
import messages from './messages';
import { activeFilters } from 'reducers/templateFilters/selectors';
import {
  addActiveFilters,
  removeFilter,
  clearFilters,
  clearAllDesignOptionFilters,
} from 'reducers/templateFilters/actions';
import { model } from 'reducers/models/selectors';

const mapStateToProps = combineSelectors({
  activeFilters,
  model,
});

export const getDropdownOptions = (options, availableOptionCodes) => {
  return availableOptionCodes.reduce((descriptions, optionId) => {
    descriptions.push(options[optionId]);
    return descriptions;
  }, []);
};

const setActiveFilters = (state, { addActiveFilters, functionalGroupId }) => ({
  newFilter,
  designOption,
}) => {
  addActiveFilters &&
    addActiveFilters(functionalGroupId, newFilter, designOption);
  return {
    ...state,
    [designOption]: [...newFilter],
  };
};

const clearFilter = (
  state,
  { functionalGroupId, removeFilter, onRemoveFilter },
) => ({ designOption, newSelectedOptions }) => {
  functionalGroupId &&
    removeFilter &&
    removeFilter(functionalGroupId, designOption, newSelectedOptions);
  onRemoveFilter();
  return {
    ...state,
    [designOption]: newSelectedOptions,
  };
};

const clearAllFilters = (
  state,
  { functionalGroupId, clearFilters },
) => preventClearGlobalFilters => {
  if (!preventClearGlobalFilters)
    clearFilters && clearFilters(functionalGroupId);
  return {
    paintOption: null,
    interiorOption: null,
    trimOption: null,
    wheelOption: null,
    colorLineOption: null,
    roofAndMirrorCapOption: null,
  };
};

function componentDidUpdate(prevProps) {
  if (
    Object.keys(prevProps.activeFilters).length &&
    !Object.keys(this.props.activeFilters).length
  ) {
    this.props.clearAllFilters(true);
  }
  if (prevProps.isOpen && !this.props.isOpen) {
    this.props.clearAllFilters();
  }
}

export default compose(
  connect(mapStateToProps, {
    addActiveFilters,
    removeFilter,
    clearFilters,
    clearAllDesignOptionFilters,
  }),
  injectIntl,
  addIntlProps({
    messages,
    propNames: [
      'exteriorFiltersHeader',
      'interiorFiltersHeader',
      'trimFiltersHeader',
      'wheelFiltersHeader',
      'roofAndMirrorCapsFiltersHeader',
      'colorLinesFiltersHeader',
      'clearFiltersText',
      'linkSearchWithinGroup',
      'linkFiltersWithinGroup',
    ],
  }),
  withStateHandlers(
    {
      paintOption: null,
      interiorOption: null,
      trimOption: null,
      wheelOption: null,
      colorLineOption: null,
      roofAndMirrorCapOption: null,
    },
    {
      setActiveFilters,
      clearFilter,
      clearAllFilters,
    },
  ),
  lifecycle({ componentDidUpdate }),
);
